import { BasicPopup } from '../BasicPopup'
import { Stack } from '@mui/material'
import { ButtonType, BUTTON_TYPE } from '../DialogFooter/Button.model'
import { ConfirmationDialogRawProps } from './ConfirmationPopup.model'
import { DialogFooter } from '../DialogFooter'

export const ConfirmationPopup = (props: ConfirmationDialogRawProps) => {
  const { onClose, open, children, title, actionType } = props

  const handleActionSubmit = (action: ButtonType) => {
    onClose(action)
  }

  return (
    <BasicPopup
      title={title}
      open={open}
      onClose={() => onClose(BUTTON_TYPE.CLOSE)}
      width={props.width}
      minWidth={props.minWidth}
    >
      <Stack
        id='message-popup-content'
        sx={{ whiteSpace: 'pre-line' }}
      >
        {children}
      </Stack>
      <DialogFooter
        type={actionType}
        onSubmit={handleActionSubmit}
      />
    </BasicPopup>
  )
}
